// Scout loads Bugsnag globally through its Rails layout, not an npm package.
export const notifyBugsnag = (error: unknown): void => {
  const client = (window as unknown as { Bugsnag?: { notify: (error: Error) => void } }).Bugsnag;
  try {
    if (typeof client?.notify === 'function') {
      client.notify(error instanceof Error ? error : new Error(String(error)));
    }
  } catch {
    // A failed error reporter must not take the shell down with it.
  }
};
